import React from 'react';
import { useCart } from '../context/CartContext';
import { X, ShoppingCart, Plus, Minus, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import API_BASE_URL from '../apiConfig';
import placeholderImage from '../assets/placeholder.webp';

const CartDrawer = ({ isOpen, onClose }) => {
  const { cartItems, removeFromCart, updateQuantity, cartTotal, totalItems, clearCart } = useCart();

  const handleUpdateQuantity = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
    } else {
      updateQuantity(productId, newQuantity);
    }
  };

  const handleClearCart = () => {
    if (window.confirm('Are you sure you want to clear your cart?')) {
      clearCart();
    }
  };

  return (
    <div
      className={`fixed inset-0 z-[100] transition-all duration-300 ${
        isOpen ? 'visible bg-black bg-opacity-50' : 'invisible'
      }`}
      onClick={onClose}
    >
      <div
        className={`fixed right-0 top-0 h-full w-[80%] md:w-96 bg-white shadow-xl transform transition-transform duration-300 overflow-y-auto ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the drawer
      >
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center space-x-2">
            <ShoppingCart size={24} />
            <span>Your Cart ({totalItems})</span>
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-red-600">
            <X size={24} />
          </button>
        </div>

        <div className="p-4 flex flex-col h-[calc(100vh-6rem)]">
          {cartItems.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <ShoppingCart size={48} className="text-gray-400 mb-4" />
              <p className="text-lg text-gray-600">Your cart is empty.</p>
              <button onClick={onClose} className="mt-4 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">Start Shopping</button>
            </div>
          ) : (
            <>
              <div className="flex-1 space-y-4 overflow-y-auto">
                {cartItems.map(item => (
                  <div key={item.id} className="flex items-center space-x-4 border-b pb-4">
                    <img
                      src={item.image ? `${API_BASE_URL}/uploads/${item.image}` : placeholderImage}
                      alt={item.name}
                      className="w-16 h-16 object-cover rounded-lg"
                    />
                    <div className="flex-1">
                      <h4 className="font-semibold">{item.name}</h4>
                      <p className="text-sm text-gray-600">₹{item.sale_price}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)} className="bg-gray-200 text-gray-700 px-2 py-1 rounded"><Minus size={16} /></button>
                      <span className="w-8 text-center">{item.quantity}</span>
                      <button onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)} className="bg-gray-200 text-gray-700 px-2 py-1 rounded"><Plus size={16} /></button>
                    </div>
                    <button onClick={() => removeFromCart(item.id)} className="text-red-500 hover:text-red-700">
                      <X size={20} />
                    </button>
                  </div>
                ))}
              </div>
              <div className="mt-auto pt-4 border-t">
                <div className="flex justify-between text-xl font-bold mb-4">
                  <span>Total:</span>
                  <span>₹{cartTotal.toFixed(2)}</span>
                </div>
                {/* New button layout */}
                <div className="flex space-x-2 mb-2">
                    <button
                        onClick={handleClearCart}
                        className="flex-1 inline-block text-center px-4 py-2 bg-red-100 text-red-600 font-bold rounded-lg hover:bg-red-200 transition-colors flex items-center justify-center space-x-2"
                    >
                        <Trash2 size={16} />
                        <span>Clear</span>
                    </button>
                     <Link to="/cart" className="flex-1 inline-block text-center px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors" onClick={onClose}>
                        View Cart
                    </Link>
                </div>
                <Link to="/checkout" className="w-full inline-block text-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors" onClick={onClose}>
                  Proceed to Checkout
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartDrawer;